import { OrderStatus } from './orders';

export enum ClientStatus {
  ACTIVE = 'ACTIVE',
  BLOCKED = 'BLOCKED'
}

export enum ClientPlatform {
  ANDROID = 'ANDROID',
  IOS = 'IOS'
}

export interface ClientResponse {
  id: number;
  name: string | null;
  phone: string;
  status: ClientStatus;
  platform?: ClientPlatform;
  createdAt: number;
}

export interface ClientsRequest {
  searchQuery: string;
  page: number;
  pageSize: number;
  status?: ClientStatus | null;
  hasOrders?: boolean;
  onlyCancelledOrders?: boolean;
  lastCompletedOrderBefore?: number;
  lastCompletedOrderAfter?: number;
  lastCompletedOrderBetweenStart?: number;
  lastCompletedOrderBetweenEnd?: number;
  lastCompletedOrderWithinDays?: number;
  minCompletedOrders?: number;
  maxCompletedOrders?: number;
  orderStatusIn?: OrderStatus[];
  createdAtFrom?: number;
  createdAtTo?: number;
  platform?: ClientPlatform;
}

export interface SendMessageToClientRequest {
  clientId: number;
  message: string;
}

export interface ChangeClientStatusRequest {
  clientId: number;
  status: ClientStatus;
}

export interface ClientOrdersRequest {
  clientId: number;
  page: number;
  pageSize: number;
}

export interface ClientOrderMinimalResponse {
  id: number;
  createdAt: number;
  orderStatus: OrderStatus;
  restaurantName: string;
  deliveryPrice: number;
  foodsPrice: number;
  totalPrice: number;
  problematicCompleteReason: string | null;
}

export interface ClientOrdersResponse {
  orders: ClientOrderMinimalResponse[];
  totalPages: number;
  totalElements: number;
  currentPage: number;
}

export interface AdminClientsPageResponse {
  clients: ClientResponse[];
  totalClients: number;
  totalPages: number;
  currentPage: number;
}

export interface ClientsFilterPayload {
  searchQuery: string;
  status: ClientStatus | null;
  hasOrders: boolean | null;
  onlyCancelledOrders: boolean | null;
  lastCompletedOrderBefore: number | null;
  lastCompletedOrderAfter: number | null;
  lastCompletedOrderBetweenStart: number | null;
  lastCompletedOrderBetweenEnd: number | null;
  lastCompletedOrderWithinDays: number | null;
  minCompletedOrders: number | null;
  maxCompletedOrders: number | null;
  orderStatusIn: OrderStatus[] | null;
  createdAtFrom: number | null;
  createdAtTo: number | null;
  platform: ClientPlatform | null;
}

export interface ClientsNotificationRequest {
  topic: 'SPECIFIC_CLIENTS';
  title: string;
  message: string;
  imageUrl?: string | null;
  clientsFilter: ClientsFilterPayload;
}
